import axios from 'axios';
import { BASEDOMAIN } from '@/constants/allconstants';
import { AuthConfig } from '@/utils/constants/configContants';
import { getToken } from '@/utils/functions/TokenFunction';

export const fetchEnvos = async (pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string, callback: any, errorCallback: any) => {
    let url = searchItem
    ? `${BASEDOMAIN}/envelope/list?offset=${dataLength * pageNo - dataLength}}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}`
    : `${BASEDOMAIN}/envelope/list?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`;
    if (filter.createdAtStart) {
        url += `&created_on_or_after=${filter.createdAtStart}`;
    }

    if (filter.createdAtEnd) {
        url += `&created_on_or_before=${filter.createdAtEnd}`;
    }

    if (filter.status) {
        url += `&status=${filter.status.value}`;
    }

    if (filter.owner) {
        url += `&owner=${encodeURIComponent(filter.owner)}`;
    }

    await axios.get(url, AuthConfig()).then((response) => {
        callback(response);
    })
    .catch((e) => {
        errorCallback(e);
        console.log(e);
    });
}

export const getEnvelopeById = async (envelopeId: string, callback: any, errorCallback: any, queryParams?: any) => {
    let url = `${BASEDOMAIN}/envelope/${envelopeId}`;
    if (queryParams) {
        const params = new URLSearchParams();
        Object.entries(queryParams).forEach(([key, value]) => {
            params.append(key, String(value));
        });
        url += `?${params.toString()}`;
    }
    axios.get(url, AuthConfig())
    .then((response) => {
        callback(response);
    })
    .catch((e) => {
        console.log(e);
        errorCallback(e);
    });
}
export const getDocumentOfEnvelope = async (envelopeId: string, documentId: string) => {
    const res = await axios.get(`${BASEDOMAIN}/envelope/${envelopeId}/document/${documentId}`, AuthConfig())
    return res.data
}

export const updateEnvelopeReviewStatus = async (envelope_id: string, payload: any) => {
    try {
        const getLocation = () =>
            new Promise((resolve) => {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            latitude: position.coords.latitude, 
                            longitude: position.coords.longitude,
                        });
                    },
                    () => {
                        resolve(null); // Resolve with null in case of error
                    }
                );
            });

        const location = await getLocation(); // Wait for location

        const headers = { 
            ...AuthConfig().headers, 
            ...(location ? { 'Location': JSON.stringify(location) } : {}) 
        };
        const result = await axios.patch(`${BASEDOMAIN}/envelope/${envelope_id}/review`, payload, { headers })
        return result
    } catch (err) {
        throw err; // Re-throw error to be handled in the catch block of the caller
    }
}

export const fetchUserEnvos = async (userId: string, pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string, callback: any, errorCallback: any) => {
    let url = searchItem
    ? `${BASEDOMAIN}/user/${userId}/envelopes?offset=${dataLength * pageNo - dataLength}}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}`
    : `${BASEDOMAIN}/user/${userId}/envelopes?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`;
    if (filter.createdAtStart) {
        url += `&created_on_or_after=${filter.createdAtStart}`;
    }

    if (filter.createdAtEnd) {
        url += `&created_on_or_before=${filter.createdAtEnd}`;
    }

    if (filter.status) {
        url += `&status=${filter.status.value}`;
    }

    if (filter.is_reported) {
        url += `&is_reported=${filter.is_reported}`;
    }

    if (filter.get_created_by) {
        url += `&get_created_by=${filter.get_created_by}`;
    }

    await axios.get(url, AuthConfig()).then((response) => {
        callback(response);
    })
    .catch((e) => {
        errorCallback(e);
        console.log(e);
    });
}

export const sendEmail = async (id: string, callback: any, setErrorShow: any = () => {}, query: any = {}) => {
    const queryString = query && typeof query === 'object' ? Object.entries(query).map(([key, value]) => `${key}=${value}`).join('&') : '';
    navigator.geolocation.getCurrentPosition(function (position) {
            var loc = JSON.stringify({
                "latitude": position.coords.latitude,
                "longitude": position.coords.longitude,
            })
            axios.post(`${BASEDOMAIN}/envelope/${id}/send?${queryString}`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`,
                    'Location': loc
                }
            }).then(res => {
                callback(id)
            }).catch(e => e?.response?.status === 401 ? {} : (setErrorShow(e)))
        },
        function (position) {
            axios.post(`${BASEDOMAIN}/envelope/${id}/send?${queryString}`, {}, {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getToken()}` }
            }).then(res => {
                callback(id)
            }).catch(e => e?.response?.status === 401 ? {} : (setErrorShow(e)))
        }
    );
}

export const transferEnvelopeOwnership = async (envelopeId: string, payload: { user_id?: string; email_address?: string }) => {
    const response = await axios.post(`${BASEDOMAIN}/envelope/${envelopeId}/transfer-ownership`, payload, AuthConfig());
    return response.data;
};